<div class="product" *ngFor="let prodotto of arrProdotti, let i = index">
    <div class="product-image">
        <a (click)="openModal(prodotto.idprod)"><img alt="Immagine prodotto" src="{{prodotto.img1}}">
        </a>
    </div>

    <div class="product-description">
        <div class="product-category">{{prodotto.categoria}}</div>
        <div class="product-title">
            <h3><a (click)="openModal(prodotto.idprod)" >{{prodotto.titolo}}</a></h3>
        </div>
        <div class="product-price" *ngIf="loggato"> 
            <img src="./assets/images/Semaforo-arancio.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita >= 1 && prodotto.disponibilita <= 10">
            <img src="./assets/images/Semaforo-verde.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita > 10">
            <img src="./assets/images/Semaforo-rosso.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita == 0">
        
            <ng-container *ngIf="prodotto.InPromo != 0">
                &nbsp; <ins>€ {{prodotto.prezzoPromo}} <span *ngIf="estero != 'SI'">(€ {{prodotto.prezzoPromoIvato}})</span></ins> 
            </ng-container>

            <ng-container *ngIf="prodotto.InPromo == 0">
                &nbsp; <ins>€ {{prodotto.prezzo}} <span *ngIf="estero != 'SI'">(€ {{prodotto.prezzoIvato}})</span></ins> 
            </ng-container>
            
        </div>
        <a class="btn btn-sm mt-1 btn-danger" routerLink="/accedi" *ngIf="!loggato">ACCEDI</a>
        
        <!-- <a class="btn btn-sm mt-1" *ngIf="loggato" (click)="addCart(prodotto)" >Aggiungi al carrello</a> -->

        <div class="cart-product-quantity qty-box" *ngIf="loggato">
            <div class="quantity">
                <input type="button" class="minus" value="-" (click)="removeQty(i)">
                <input type="text" class="qty" value="1" name="quantity" [(ngModel)]="prodotto.qty">
                <input type="button" class="plus" value="+" (click)="addQty(i)">
            </div>
            <a class="btn" (click)="addCart(prodotto)"><span class="material-icons icoCart">
                add_shopping_cart
                </span></a>
        </div>
    </div>
</div>

<app-modal-scheda-prod2 #modal2 [modalConfig]="modalConfig">
    <app-scheda-prodotto #schedaProd2 [idProdotto]="idProdotto" (childEvent)="closeModal($event)"></app-scheda-prodotto>
  </app-modal-scheda-prod2>